var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.dashboard_pipeline)?_c('a',{staticClass:"hidden-sm-down",attrs:{"href":"https://sensor.mdevelopment.dk","target":"_blank","id":"pipeline-link"}},[_c('b',[_vm._v("Pipeline")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b1a3e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/topbar/links.vue
// module id = 4d9x
// module chunks = 32